import React, {useMemo, useState} from 'react';
import { Tab, Tabs} from '@blueprintjs/core';

import JSONEditor from '../../../JSONEditor';
import {ResultDate} from './ResultDate';

interface ApiResultSuccessProps {
  result: any;
}

enum TAB {
  DATA = 'tab_data',
  DETAILS = 'tab_details',
}

const EDITOR_OPTIONS: any = {
  maxLines: 10,
  useWorker: false,
  wrap: true,
}

const onChangeFake = () => {};

export const ApiResultSuccess = ({
  result,
}: ApiResultSuccessProps) => {
  const [tab, setTab] = useState<any>(TAB.DATA);
  const response = result?.value?.response_json || {};
  const defaultData = useMemo(() => JSON.stringify(response, null, 2), [response]);
  const defaultDetails = useMemo(() => JSON.stringify(result, null, 2), [result]);

  return (
    <>
      <Tabs
        onChange={setTab}
        defaultSelectedTabId={tab}
        animate={false}
      >
        <Tab
          id={TAB.DATA}
          title="Data"
          panel={
            <JSONEditor
              defaultValue={defaultData}
              disabled={true}
              onChange={onChangeFake}
              editorOptions={EDITOR_OPTIONS}
            />
          }
        />
        <Tab
          id={TAB.DETAILS}
          title="Details"
          panel={
            <JSONEditor
              defaultValue={defaultDetails}
              disabled={true}
              onChange={onChangeFake}
              editorOptions={EDITOR_OPTIONS}
            />
          }
        />
      </Tabs>
      <ResultDate result={result}/>
    </>
  )
};
